import DomUtils from './../utils/dom-utils';

const PartenairePro = {
    menu_list: [],
    select_list: [],
    menu_items: [],
    menu_selector: '.menu-partenaire-pro',
    menu_item_selector: '.vertical-timeline-menu-item',
    tab_item_selector: '.vertical-timeline-tab',
    tab_wrappers_selector: '.strate-partenaire-pro-wrapper',
    // currentURL: window.location.href,
    tab_wrappers: [],
    sender: 'partenaire',
    currentSender: 'partenaire',
    oldOffset: {},
    init () {
        let menu_partenaire_pro_elements = document.querySelectorAll(this.menu_selector);
        let _self = this;
        // console.log('menu_partenaire_pro_elements: ', menu_partenaire_pro_elements);
        if (menu_partenaire_pro_elements.length > 0) {
            [].forEach.call(menu_partenaire_pro_elements, function (menu, menuId) {
                let menuItems = menu.querySelectorAll(_self.menu_item_selector);
                _self.menu_list[menuId] = menu;
                _self.menu_items[menuId] = menuItems;
                _self.tab_wrappers[menuId] = DomUtils.getClosest(menu, _self.tab_wrappers_selector);
                // console.log(_self.tab_wrappers[menuId]);
                _self.select_list[menuId] = _self.tab_wrappers[menuId].querySelector('select');
                if (_self.select_list[menuId]) {
                    _self.select_list[menuId].addEventListener('change', function (event) {
                        // console.log('change: ', event.currentTarget.value);
                        _self.selectTab(event.currentTarget.value, DomUtils.getClosest(event.currentTarget, _self.menu_selector).dataset.menuId);
                        menuItems[parseInt(event.currentTarget.value.charAt(event.currentTarget.value.length - 1))].click();
                    })
                }
                
                menu.dataset.menuId = menuId;
                // console.log('menuItems:',menuItems);
                [].forEach.call(menuItems, function (menuItem, index) {
                    menuItem.addEventListener('click', function (event) {
                        // je n'envoi plus d'événement si c'était pas moi qui l'a créé
                        if (_self.currentSender == _self.sender) {
                            var tabCCMPartenaireEvent = new CustomEvent('changeTab');
                            tabCCMPartenaireEvent.tabIndex = index;
                            tabCCMPartenaireEvent.sender = _self.sender;
                            _self.oldOffset = document.getElementById('partenaires-pro-wrapper').getBoundingClientRect();
                            document.dispatchEvent(tabCCMPartenaireEvent);
                            _self.jump('partenaires-pro-wrapper');
                        }
                        // on me réinfecte l'envoi
                        _self.currentSender = _self.sender;
                        _self.selectTab(event.currentTarget.dataset.tab, DomUtils.getClosest(event.currentTarget, _self.menu_selector).dataset.menuId);
                    });
                });

                document.addEventListener('changeTab', e => {
                    if (e.sender != _self.sender) {
                        _self.currentSender = 'notMe';
                        // console.log(e);
                        menuItems[e.tabIndex].click();
                    }
                });
            });
        }
    },

    selectTab (id, menuId) {
        console.log('selectTab:', id, menuId, this);
        [].forEach.call(this.menu_items[menuId], function (menuItem) {
            if (menuItem.dataset.tab == id) {
                menuItem.classList.add('active');
            } else {
                menuItem.classList.remove('active');
            }
        });

        const tabs = this.tab_wrappers[menuId].querySelectorAll(this.tab_item_selector);
        [].forEach.call(tabs, function (tab) {
            if (tab.dataset.tabId == id) {
                tab.classList.remove('hide');
            } else {
                tab.classList.add('hide');
            }
        });

        /* var tabCCMPartenaireEvent = new CustomEvent('changeTab');
        tabCCMPartenaireEvent.tabIndex = index;
        tabCCMPartenaireEvent.sender = _self.sender;
        document.dispatchEvent(tabCCMPartenaireEvent); */

        setTimeout(function () {
            window.dispatchEvent(new Event('resize'));
        }, 50);

        if (this.select_list[menuId]) {
            this.select_list[menuId].value = id;
        }
    },

    offset(elt) {
        var rect = elt.getBoundingClientRect(), bodyElt = document.body;
        console.log('rect.top:', rect.top, 'pageYOffset:', window.pageYOffset, 'y:', rect.y);
        return {
            top: rect.top + window.pageYOffset,
            left: rect.left + bodyElt.scrollLeft,
            rect: rect
        }
    },

    jump(h){
        const offset = this.offset(document.getElementById(h));
        console.log('offset:', offset.top, window.scrollY);
        document.querySelector('html').style.scrollBehavior = 'initial';
        window.scrollTo(0, offset.top - this.oldOffset.top);
        setTimeout(() => {
            document.querySelector('html').style.scrollBehavior = 'smooth';
        }, 100);
    }
}

export default PartenairePro